//only used in test drive apps, will be changed in future development using existing api-proxy.ts

import { captureException } from '@sentry/nextjs';
import axios from 'axios';
import querystring from 'qs';
import { httpKeepAliveAgent, httpsKeepAliveAgent } from '../helpers/utils/connectionPoolConfig';

const BASE_URL = process.env.NEXT_PUBLIC_HYBRIS_BASE_URL;
const TIMEOUT = 15000;

const api = axios.create({
  httpAgent: httpKeepAliveAgent,
  httpsAgent: httpsKeepAliveAgent,
  baseURL: BASE_URL,
  timeout: TIMEOUT,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  paramsSerializer: (params) => querystring.stringify(params),
});

const APIInstance = {
  /**
   * @param {Sring} url '/path/to/endpoint'
   * @param {Object} param query params
   */
  get: (url, customConfig = {}) => {
    return api.get(url, {
      ...customConfig,
    });
  },

  /**
   * @param {Sring} url '/path/to/endpoint'
   * @param {Object} json
   * @param {Object} form
   * @param {Object} reqConfig  custom config for request
   */
  post: (url, form = null, json = {}, reqConfig = {}) => {
    api.defaults.headers['Content-Type'] = form
      ? 'application/x-www-form-urlencoded'
      : 'application/json';

    const data = querystring.stringify(form) || json;
    return api.post(url, data, {
      params: querystring.stringify(form),
      ...reqConfig,
    });
  },
};

api.interceptors.response.use(
  async (response) => response,
  async function (error) {
    const originalRequest = error.config;
    // capture error to sentry
    captureException(error);
    if (error?.response?.status === 401) {
      try {
        originalRequest._retry = true;
        const res = await getToken();
        originalRequest.headers['Authorization'] = `Bearer ${res.data.access_token}`;
        return api(originalRequest);
      } catch (_) {
        // console.log(err);
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  }
);

const getToken = (): Promise<{
  data: {
    access_token: string;
    token_type: string;
    expires_in: number;
    scope: string;
  };
}> => {
  const res = APIInstance.post('/authorizationserver/oauth/token', {
    grant_type: 'client_credentials',
    client_id: process.env.HYBRIS_CLIENT_ID,
    client_secret: process.env.HYBRIS_CLIENT_SECRET,
  });
  return res;
};

export default {
  APIInstance,
  getToken,
};
